import StudioFeaturesNavigationBar from "@components/BasicComponents/DBStudio/StudioFeaturesNavigationBar/StudioFeaturesNavigationBar"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAsset from "@components/WebsiteRevamp/ContentAsset/ContentAsset"
import {direction} from "@customTypes/customTypes"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./FeatureSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
	direction: direction
	cardDirection: direction
	linkPanel: AdvancedSideAssetMainContent[]
	activeIndex: number
}

const FeatureSection = (props: Props) => {
	const data = props.data.mainContent
	const idForSectionG =
		props.linkPanel?.[props.activeIndex]?.buttons?.[0]?.link?.substring(1)
	return (
		<section style={{overflow: "hidden"}}>
			<ContainerWrapper
				className={`${styles.container}`}
				id={idForSectionG}
			>
				<StudioFeaturesNavigationBar
					active={props.activeIndex}
					data={props.linkPanel}
				/>
				<Separator size={128} />
				{data?.map(
					(element: AdvancedSideAssetMainContent, index: number) => {
						return (
							<React.Fragment key={index}>
								<ContentAsset data={element} withAspectRation />
								{index + 1 < data.length && (
									<Separator size={128} />
								)}
							</React.Fragment>
						)
					},
				)}
			</ContainerWrapper>
			<Separator size={128} />
		</section>
	)
}

export default FeatureSection
